// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Perfil_MeuInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /perfil/meu — grava os dados pessoais de QUEM ESTÁ LOGADO: a pessoa vem do token, nunca
 * do corpo. Aceita rascunho incompleto; CPF, data e UF inválidos são recusados.
 */
import { registerContract } from './validate'

export interface Perfil_MeuInput {
nome_completo?: string
cpf?: string
rg?: string
data_nascimento?: string
estado_civil?: string
profissao?: string
telefone?: string
cep?: string
endereco?: string
numero?: string
complemento?: string
bairro?: string
cidade?: string
uf?: string
}

registerContract('Perfil_MeuInput', {
  nome_completo:   { type: 'string',  required: false },
  cpf:             { type: 'string',  required: false },
  rg:              { type: 'string',  required: false },
  data_nascimento: { type: 'string',  required: false },
  estado_civil:    { type: 'string',  required: false },
  profissao:       { type: 'string',  required: false },
  telefone:        { type: 'string',  required: false },
  cep:             { type: 'string',  required: false },
  endereco:        { type: 'string',  required: false },
  numero:          { type: 'string',  required: false },
  complemento:     { type: 'string',  required: false },
  bairro:          { type: 'string',  required: false },
  cidade:          { type: 'string',  required: false },
  uf:              { type: 'string',  required: false },
})
